/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-routers components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function ListCard({
  title = "",
  description = "",
  list = [],
  icon = null,
}) {
    const renderlist = list.map(({ title, subtitle, action }) => (
      <MDBox key={title} component="li" display="flex" alignItems="center" py={1} mb={1} sx={{ width: "100%", minWidth: 0 }}>
        <MDBox display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center" sx={{ width: "100%", minWidth: 0 }}>
          <MDTypography
            variant="button"
            fontWeight="medium"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
              minWidth: 0
            }}
          >
            {title}
          </MDTypography>
          <MDTypography variant="caption" color="text" sx={{ width: "100%", minWidth: 0 }}>
            {subtitle}
          </MDTypography>
        </MDBox>
        <MDBox ml="auto">
          {action.type === "internal" ? (
            <MDButton component={Link} to={action.route} variant="text" color="info">
              {action.label}
            </MDButton>
          ) : (
            <MDButton
              component="a"
              href={action.route}
              target="_blank"
              rel="noreferrer"
              variant="text"
              color={action.color}
            >
              {action.label}
            </MDButton>
          )}
        </MDBox>
      </MDBox>
    ));

  return (
    <Card>
      <MDBox py={2} pr={2} pl={icon.component ? 1 : 2}>
        <MDBox display="flex" px={description ? 1 : 0} pt={description ? 1 : 0}>
          <MDBox
            width="4rem"
            height="4rem"
            bgColor={icon.color || "dark"}
            variant="gradient"
            coloredShadow={icon.color || "dark"}
            borderRadius="xl"
            display="flex"
            justifyContent="center"
            alignItems="center"
            color="white"
            mt={-5}
            mr={2}
          >
            <Icon fontSize="medium">{icon.component}</Icon>
          </MDBox>
          <MDBox mt={icon.component ? -2 : 0}>
            {title && <MDTypography variant="h6">{title}</MDTypography>}
            <MDBox mb={2}>
              <MDTypography component="div" variant="button" color="text">
                {description}
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>

        <MDBox pl={2}>
          <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
            {renderlist}
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

ListCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  icon: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "light",
      "dark",
    ]),
    component: PropTypes.node,
  }),};

export default ListCard;
